
import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config';

export const deleteStockCatalogAndStockReference = async(data) => {
  const result = await axios
    .patch(
      `${REACT_APP_PERITADOR_API}/takingCarManagment/deleteStockCatalogAndStockReference`,
      {...data}
    )
  return result?.data
}
